import { PayloadAction } from "@reduxjs/toolkit";
import communityApi from "api/community";
import { call, put, takeLatest } from 'redux-saga/effects';
import { communityActions } from "redux/reducers/community";
import { Community } from "types";

function* getCommunityById(data: PayloadAction<string>) {
  try {
    const response: Community = yield call(communityApi.getCommunityById, data.payload);
    yield put(communityActions.fetchCommunitySuccess(response));
  } catch (error) {
    console.log(`Failed to fetch community`, error);
    yield put(communityActions.fetchCommunityFailed(error));
  }
}

export default function* communitySaga() {
  yield takeLatest(communityActions.fetchCommunity.type, getCommunityById);
}
